import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { UtilService } from 'src/app/core/utilities/util.service';
import { BaseComponent } from 'src/app/shared/base/BaseComponent';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-login-dashboard',
  templateUrl: './login-dashboard.component.html',
  styleUrls: ['./login-dashboard.component.scss'],
})
export class LoginDashboardComponent extends BaseComponent implements OnInit {
  constructor(
    translateService: TranslateService,
    public utilService: UtilService
  ) {
    super(translateService);

    this.translateService.onLangChange.subscribe((langChangeEvent) => {});
  }

  ngOnInit(): void {}

  openUserManual(path: string) {
    if (this.isEnglish) {
      window.open(path + 'en/UserManualEn.pdf');
    } else {
      window.open(path + 'ar/UserManualAr.pdf');
    }
  }

  goTo(key: string) {
    const url = environment[key as keyof typeof environment];
    if (typeof url === 'string') {
      window.open(url, '_blank');
    } else {
      console.error(`Invalid URL for key: ${key}`);
    }
  }
}
